import React, { useState, useRef } from "react";
import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import {
  getErrorMessageByKey,
  useNotification,
  useObject,
  Input,
  useList,
  Select,
  getAccountFio,
  jsonFormatText,
  isValidateNullText,
  Modal,
} from "@vokymlak/kabinet-ui";

function ModalCategoryFromGroup(props) {
  const {
    object: [object],
  } = useObject({
    apiUrl: "/api/nomenclature-category/" + props.object.uuid,
    rootUrl: ROOT_URL,
    callbackError: () => {
      props.handleClose();
    },
  });

  const { notification } = useNotification();

  const changeEdit = (event) => {
    event.preventDefault();

    axios
      .get("/api/nomenclature-category/" + props.object.uuid + "/from-category-group", {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Данные сохранены", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  return (
    !!object && (
      <Modal handleClose={() => props.handleClose()}>
          <form className="Form" onSubmit={(event) => changeEdit(event)}>
            <div className="Form__title">
              {object.title}
              <div className="Text__signature">Вынести из группу</div>
            </div>

            <div className="Form__actions Form__actions_center">
              <button className="Action__button Action__button_all Action__button_gray">
                Вынести
              </button>
            </div>
          </form>
      </Modal>
    )
  );
}

export default ModalCategoryFromGroup;
